import React from "react";
import UserProfile from "./User";
import BusinessProfile from "./Business";

export default function index() {
  return (
    <div>
      <div className="border-b border-zinc-300 pb-3 ">
        <div className="ml-12 border-l border-zinc-300 pl-4">
          <h1 className="text-2xl font-bold leading-tight tracking-tight text-zinc-800">Cuenta</h1>
        </div>
      </div>
      <div className="space-y-10 divide-y">
        <div className="bg-white p-4 rounded-2xl">
          <BusinessProfile />
        </div>
        <div className="bg-white p-4 rounded-2xl">
          <UserProfile />
        </div>
      </div>
    </div>
  );
}
